import { inject } from '@angular/core';
import { TRANSLATED_URLS } from '@core/api/constants/translated-urls.constants';
import { SearchEngines } from '@core/constants/search-engines';
import { WINDOW } from '@noda-lib/utils/injection';
import { PlatformService } from '@noda-lib/utils/services';
import { NODA_FORM_LINK } from '@shared/constants/links';

export function isScreenGreaterThan(width: number): boolean {
  const window: Window = inject(WINDOW);
  const platformService: PlatformService = inject(PlatformService);

  if (platformService.isBrowser()) {
    return window.matchMedia(`(min-width: ${width}px)`).matches;
  }

  return undefined;
}

export function isNodaFormUrl(url: string): boolean {
  const nodaFormUrl: URL = new URL(NODA_FORM_LINK);
  const urlToCheck: string = nodaFormUrl.origin + nodaFormUrl.pathname;

  return url.startsWith(urlToCheck);
}

export function isPathAvailableWithTranslations(
  routes: ReadonlyArray<string>,
  pathToCheck: string,
): boolean {
  const normalizedPath = pathToCheck.startsWith('/') ? pathToCheck.slice(1) : pathToCheck;

  return routes.some(route =>
    TRANSLATED_URLS[route]
      ? [route, ...Object.values(TRANSLATED_URLS[route])].includes(normalizedPath)
      : route === normalizedPath,
  );
}

export function getOriginalPath(path: string): string {
  const originalPath: string | undefined = Object.keys(TRANSLATED_URLS).find(p =>
    Object.values(TRANSLATED_URLS[p]).includes(path),
  );

  return originalPath || path;
}

export function randomid(): string {
  return crypto.randomUUID();
}

export function isSearchEngine(referrer: string): boolean {
  return SearchEngines.some((engine: string) => referrer.includes(engine));
}
